import { render } from "./CallSvg.vue?vue&type=template&id=9ea95690"
import script from "./CallSvg.vue?vue&type=script&lang=js"
export * from "./CallSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__